module.exports = __webpack_public_path__ + "static/media/add_icon.a57b9513.svg";